import React from 'react';

import { useModals } from '@shared/contexts';

import { ModalName } from '@components/modals';

import { Nav } from './components/nav';
import { Profile } from './components/profile';
import * as Styled from './header.styled.ts';

const Header = () => {
	const { openModal } = useModals();

	const openAuthModalHandler = () => {
		openModal(ModalName.LOGIN);
	};

	return (
		<>
			<Styled.Wrapper>
				<Styled.Container>
					<Nav />
					<Profile openAuth={openAuthModalHandler} />
				</Styled.Container>
			</Styled.Wrapper>
			<Nav isMobile />
		</>
	);
};

export default Header;
